const _Loader = require("util/Loader");
const _Misc = require("util/Misc");
const _Formatter = require("util/Formatter");
const _Looper = require("util/Looper");
const _Html = require("util/Html");

const Charts = {
    invoke(cb) {
        if (Charts.busy)
            return;
        Charts.busy = true;
        _Loader.script("/vendor/Chart.min.js", "Chart", function () {
            Charts.initComplete();
            Charts.busy = false;
            cb();
        });
    },

    initComplete(){
        Charts.initialized = true;
    },

    generateColors(){
        let bgs = [];
        let bs = [];
        for(let i = 0; i < 100; i ++){
            let c1 = _Misc.randomNumber(0, 255);
            let c2 = _Misc.randomNumber(0, 255);
            let c3 = _Misc.randomNumber(0, 255);
            bgs.push("rgba(" + c1 + "," + c2 + "," + c3 + ", 0.4)");
            bs.push("rgba(" + c1 + "," + c2 + "," + c3 + ", 1)");
        }
        Charts.colors = {
            backgroundColor : bgs,
            borderColor: bs
        };
    },

    trackerSummaryChart(chartData){
        let $elm = chartData.$div;
        $elm.empty().append("<canvas></canvas>");
        Charts.generateColors();
        let $c = $("canvas", $elm);

        let isStacked = chartData.labels.length > 10;

        return new Chart($c, {
            type: 'bar',
            data: {
                labels : chartData.labels,
                datasets: [{
                    label : "Income",
                    data : chartData.incomes,
                    backgroundColor: _Misc.shadeColor("#4caf50", 0.3),
                    borderColor : _Misc.shadeColor("#4caf50", 1),
                    borderWidth : 1

                },{
                    label : "Expenses",
                    data : chartData.expenses,
                    backgroundColor: _Misc.shadeColor("#ef9000", 0.3),
                    borderColor : _Misc.shadeColor("#ef9000", 1),
                    borderWidth : 1
                },{
                    label : "Allocations",
                    data : chartData.allocations,
                    backgroundColor: _Misc.shadeColor("#4F84C4", 0.3),
                    borderColor : _Misc.shadeColor("#4F84C4", 1),
                    borderWidth : 1
                }]
            },
            options: {
                legend: {
                    display: false
                },
                tooltips: {
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        label : function(tooltipItem, data) {
                            let dataset = data.datasets[tooltipItem.datasetIndex];
                            let lb = dataset.label;
                            var currentValue = dataset.data[tooltipItem.index];
                            if(currentValue === 0)
                                return null;
                            return " " + lb + ": " + _Formatter.money(currentValue, true);
                        }
                    }
                },
                responsive: true,
                scales: {
                    xAxes: [{
                        stacked: isStacked,
                    }],
                    yAxes: [{
                        stacked: isStacked,
                        ticks: {
                            beginAtZero:true,
                            callback: function(value, index, values) {
                                if(value < 0)
                                    return "-" + _Formatter.shortMoney(value);
                                return _Formatter.shortMoney(value);
                            }
                        }
                    }]
                }
            }
        });
    },

/*
    var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var color = Chart.helpers.color;
var horizontalBarChartData = {
    labels: ["January", "February", "March", "April", "May", "June", "July"],
    datasets: [{
        label: 'Dataset 1',
        backgroundColor: color(window.chartColors.red).alpha(0.5).rgbString(),
        borderColor: window.chartColors.red,
        borderWidth: 1,
        data: [
            randomScalingFactor(),
            randomScalingFactor(),
            randomScalingFactor(),
            randomScalingFactor(),
            randomScalingFactor(),
            randomScalingFactor(),
            randomScalingFactor()
        ]
    }, {
        label: 'Dataset 2',
        backgroundColor: color(window.chartColors.blue).alpha(0.5).rgbString(),
        borderColor: window.chartColors.blue,
        data: [
            randomScalingFactor(),
            randomScalingFactor(),
            randomScalingFactor(),
            randomScalingFactor(),
            randomScalingFactor(),
            randomScalingFactor(),
            randomScalingFactor()
        ]
    }]

};

window.onload = function() {
    var ctx = document.getElementById("canvas").getContext("2d");
    window.myHorizontalBar = new Chart(ctx, {
        type: 'horizontalBar',
        data: horizontalBarChartData,
        options: {
            // Elements options apply to all of the options unless overridden in a dataset
            // In this case, we are setting the border of each horizontal bar to be 2px wide
            elements: {
                rectangle: {
                    borderWidth: 2,
                }
            },
            responsive: true,
            legend: {
                position: 'right',
            },
            title: {
                display: true,
                text: 'Chart.js Horizontal Bar Chart'
            }
        }
    });

};*/


    dashboardHabitChart(chartData){
        let $elm = chartData.$div;
        $elm.empty().append("<canvas></canvas>");
        Charts.generateColors();
        let $c = $("canvas", $elm);

        let lbsCount = chartData.labels.length;
        let isStacked = chartData.labels.length > 10;

        return new Chart($c, {
            type: 'horizontalBar',
            data: {
                labels : chartData.labels,
                datasets: [{
                    label : "Income",
                    data : chartData.incomes,
                    backgroundColor: _Misc.shadeColor("#4caf50", 0.3),
                    borderColor : _Misc.shadeColor("#4caf50", 1),
                    borderWidth : 1

                },{
                    label : "Expenses",
                    data : chartData.expenses,
                    backgroundColor: _Misc.shadeColor("#ef9000", 0.3),
                    borderColor : _Misc.shadeColor("#ef9000", 1),
                    borderWidth : 1
                },{
                    label : "Allocations",
                    data : chartData.allocations,
                    backgroundColor: _Misc.shadeColor("#4F84C4", 0.3),
                    borderColor : _Misc.shadeColor("#4F84C4", 1),
                    borderWidth : 1
                }]
            },
            options: {
                legend: {
                    display: false
                },
                tooltips: {
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        label : function(tooltipItem, data) {
                            let dataset = data.datasets[tooltipItem.datasetIndex];
                            let lb = dataset.label;
                            var currentValue = dataset.data[tooltipItem.index];
                            if(currentValue === 0)
                                return null;
                            return " " + lb + ": " + _Formatter.money(currentValue, true);
                        }
                    }
                },
                responsive: true,
                scales: {
                    xAxes: [{
                        stacked: isStacked,
                        ticks: {
                            beginAtZero: false,
                            callback: function(value, index, values) {
                                return _Formatter.shortMoney(value);
                            }
                        }
                    }],
                    yAxes: [{
                        stacked: isStacked,
                        ticks: {
                            beginAtZero:true,
                            callback: function(value, index, values) {

                                let lbH = lbsCount * 18;
                                let ch = $c.height();
                                if(lbH > ch){
                                    if((lbsCount/4 * 18) > ch){
                                        if(index % 5 == 0)
                                            return value;
                                    }
                                    else if((lbsCount/3 * 18) > ch){
                                        if(index % 4 == 0)
                                            return value;
                                    }
                                    else if((lbsCount/2 * 18) > ch){
                                        if(index % 3 == 0)
                                            return value;
                                    }
                                    else if(index % 2 == 0){
                                        return value;
                                    }
                                    return "";
                                }
                                return value;
                            }
                        }
                    }]
                }
            }
        });
    },

    dashGoalChart(chartData){
        let $elm = chartData.$div;
        $elm.empty().append("<canvas></canvas>");
        let $c = $("canvas", $elm);
        let chart = new Chart($c, {
            type: "polarArea",
            data: {
                labels : chartData.labels,
                datasets: [{
                    data : chartData.percentages,
                    backgroundColor: chartData.bgs,
                    borderColor :  chartData.bcs,
                    borderWidth : 1

                }]
            },
            options: {
                responsive: false,
                title: {
                    display: true,
                    text: chartData.title,
                    padding : 15,
                    fontStyle : "normal"
                },
                tooltips: {
                    callbacks: {
                        label : function(tooltipItem, data) {
                            let dataset = data.datasets[tooltipItem.datasetIndex];
                            let lb = data.labels[tooltipItem.index];
                            var currentValue = dataset.data[tooltipItem.index];
                            if(currentValue === 0)
                                return null;
                            return " " + lb + ": " + _Formatter.percentage(currentValue);
                        }
                    }
                },
                legend: false,
                scale: {
                    ticks: {
                        beginAtZero: true,
                        callback:function(value, index, values) {
                            return value + "%";
                            //return _Formatter.shortMoney(value);
                        }
                    },
                    reverse: false
                },
                animation: {
                    animateRotate: false,
                    animateScale: true
                }
            }
        });
        return chart;
    },


/*    var randomScalingFactor = function() {
        return Math.round(Math.random() * 100);
    };

var chartColors = window.chartColors;
var color = Chart.helpers.color;
var config = {
    data: {
        datasets: [{
            data: [
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
            ],
            backgroundColor: [
                color(chartColors.red).alpha(0.5).rgbString(),
                color(chartColors.orange).alpha(0.5).rgbString(),
                color(chartColors.yellow).alpha(0.5).rgbString(),
                color(chartColors.green).alpha(0.5).rgbString(),
                color(chartColors.blue).alpha(0.5).rgbString(),
            ],
            label: 'My dataset' // for legend
        }],
        labels: [
            "Red",
            "Orange",
            "Yellow",
            "Green",
            "Blue"
        ]
    },
    options: {
        responsive: true,
        legend: {
            position: 'right',
        },
        title: {
            display: true,
            text: 'Chart.js Polar Area Chart'
        },
        scale: {
            ticks: {
                beginAtZero: true
            },
            reverse: false
        },
        animation: {
            animateRotate: false,
            animateScale: true
        }
    }
};

window.onload = function() {
    var ctx = document.getElementById("chart-area");
    window.myPolarArea = Chart.PolarArea(ctx, config);
};

document.getElementById('randomizeData').addEventListener('click', function() {
    config.data.datasets.forEach(function(piece, i) {
        piece.data.forEach(function(value, j) {
            config.data.datasets[i].data[j] = randomScalingFactor();
        });
    });
    window.myPolarArea.update();
});

var colorNames = Object.keys(window.chartColors);
document.getElementById('addData').addEventListener('click', function() {
    if (config.data.datasets.length > 0) {
        config.data.labels.push('data #' + config.data.labels.length);
        config.data.datasets.forEach(function(dataset) {
            var colorName = colorNames[config.data.labels.length % colorNames.length];
            dataset.backgroundColor.push(window.chartColors[colorName]);
            dataset.data.push(randomScalingFactor());
        });
        window.myPolarArea.update();
    }
});
document.getElementById('removeData').addEventListener('click', function() {
    config.data.labels.pop(); // remove the label first
    config.data.datasets.forEach(function(dataset) {
        dataset.backgroundColor.pop();
        dataset.data.pop();
    });
    window.myPolarArea.update();
});*/


























createLegendItems($legendWrapper, labels, dp, html){
        let items = [];
        _Looper.array(labels, function(item, idx){
            let brc = Charts.colors.borderColor[idx];
            let bgc = Charts.colors.backgroundColor[idx];
            let amount = _Formatter.money(dp[idx]);
            items.push({label : item, brc : brc, bgc : bgc, amount : amount, sortOn : dp[idx]});
        });
        _Misc.sort(items, "sortOn");
        _Looper.array(items, function(item, idx){
            if(idx > 6)
                return;
            _Html.insert($legendWrapper, html, item);
        });
    },

    snapPieChart($elm, labels, dp, legendHtml){
        $elm.empty().append("<canvas></canvas>");
        let $c = $("canvas", $elm);
        let $l = $(".legend", $elm.parent()).empty();
        Charts.generateColors();
        if(legendHtml)
            Charts.createLegendItems($l, labels, dp, legendHtml);

        return new Chart($c, {
            type: 'doughnut',
            data : {
                datasets: [{
                    data : dp,
                    backgroundColor: Charts.colors.backgroundColor,
                    borderColor: Charts.colors.borderColor,
                    borderWidth: 1
                }],
                labels: labels
            },
            options: {
                responsive : false,
                legend: {
                    display: false
                },

                tooltips: {
                    callbacks: {
                        label : function(tooltipItem, data) {
                            let dataset = data.datasets[tooltipItem.datasetIndex];
                            let lb = data.labels[tooltipItem.index];
                            var currentValue = dataset.data[tooltipItem.index];
                            return " " + lb + ": " + _Formatter.money(currentValue);
                        }
                    }
                },
            }
        });
    },

    pieChart($elm, dp, labels, bgCols, brCols, hideTooltip){
        $elm.empty().append("<canvas></canvas>");
        if(!bgCols){
            Charts.generateColors();
        }
        else{
            Charts.colors = {
                backgroundColor : bgCols,
                borderColor: brCols
            };
        }
        return new Chart($("canvas", $elm), {
            type: 'doughnut',
            data : {
                datasets: [{
                    data : dp,
                    backgroundColor: Charts.colors.backgroundColor,
                    borderColor: Charts.colors.borderColor,
                    borderWidth: 1
                }],
                labels: labels
            },
            options: {
                responsive : false,
                legend: {
                    display: false
                },

                tooltips: {
                    enabled: !hideTooltip,
                    callbacks: {
                        label : function(tooltipItem, data) {
                            let dataset = data.datasets[tooltipItem.datasetIndex];
                            let lb = data.labels[tooltipItem.index];
                            var currentValue = dataset.data[tooltipItem.index];
                            return " " + lb + ": " + _Formatter.money(currentValue);
                        }
                    }
                },
            }
        });
    },

    budgetLineChart($elm, dp, xLb, bgCols, brCols){
        $elm.empty().append("<canvas></canvas>");
        Charts.colors = {
            backgroundColor : bgCols,
            borderColor: brCols
        };
        return new Chart($("canvas", $elm), {
            type: 'bar',
            data : {
                datasets: [{
                    data : dp,
                    backgroundColor: Charts.colors.backgroundColor,
                    borderColor: Charts.colors.borderColor,
                    borderWidth: 1
                }],
                labels: xLb
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            callback: function(value, index, values) {
                                return "";
                            }
                        }
                    }]
                },
                responsive : true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },

                tooltips: {
                    enabled: false
                },
            }
        });
    },

    budgetLineChart($elm, dp, xLb, bgCols, brCols){
        $elm.empty().append("<canvas></canvas>");
        Charts.colors = {
            backgroundColor : bgCols,
            borderColor: brCols
        };
        return new Chart($("canvas", $elm), {
            type: 'bar',
            data : {
                datasets: [{
                    data : dp,
                    backgroundColor: Charts.colors.backgroundColor,
                    borderColor: Charts.colors.borderColor,
                    borderWidth: 1
                }],
                labels: xLb
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            callback: function(value, index, values) {
                                return "";
                            }
                        }
                    }]
                },
                responsive : true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },

                tooltips: {
                    enabled: false
                },
            }
        });
    },

    barChart($elm, dp){
        var normativeData = [{x: "8:00", y: 50} , {x: "20:00", y: 50}] //horizontal const line
        var productivityData = [40, 41, 45, 50, 55, 60];
        let xDp = [{x: 0, y: 10}, {x: 0, y: 1}, {x: 1, y: 6}, {x: 4, y: 2}];

        var myChart = new Chart($elm, {
            type: 'bar',
            data: {
                labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
                datasets: [{
                    label: '# of Votes',
                    data: dp,
                    borderWidth: 1
                }]
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero:true
                        }
                    }]
                },
                legend: {
                    display: true,
                    labels: {
                        fontColor: 'rgb(0, 0, 0)'
                    }
                }
            }
        });
    },

    trackerChart($elm, lbs, expenseDS, incomeDS){
        let $c = $("canvas",$elm.empty().append("<canvas></canvas>"));
        let n = lbs.length;
        let modVal = 1;
        let smallScreen = $elm.width() < 400;
        if(n > 10)
            modVal = parseInt(n/10);
        else if(n > 20)
            modVal = parseInt(n/7);
        var horizontalBarChartData = {
            labels: lbs,
            datasets: [expenseDS, incomeDS]
        };
        var myHorizontalBar = new Chart($c, {
            type: 'horizontalBar',
            data: horizontalBarChartData,
            options: {
                onClick : function(e, i){
                    console.log("ON CLICK IN CHART");
                    console.log(e);
                    e = i[0];
                    console.log(e._index)
                    var x_value = this.data.labels[e._index];
                    var y_value = this.data.datasets[0].data[e._index];
                    console.log(x_value);
                    console.log(y_value);
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltipItem, data) {
                            if(parseInt(tooltipItem.xLabel) < 0)
                                return "-$" + Math.abs(parseInt(tooltipItem.xLabel));
                            return "$" + tooltipItem.xLabel;
                        }
                    }
                },
                scales: {
                    yAxes:[{
                        display: !smallScreen,
                        ticks: {
                            beginAtZero:true,
                            callback: function(value, index, values) {
                                if(index % modVal == 0)
                                    return value;
                                return "";

                            }
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            beginAtZero:true,
                            callback: function(value, index, values) {
                                if(parseInt(value) < 0)
                                    return "-$" + Math.abs(parseInt(value));
                                return '$' + value;
                            }
                        }
                    }]
                },
                legend: {
                    display: false,
                }
            }
        });
        return myHorizontalBar;
    },

    trackerChart12($elm, expenses, income){
        $elm.empty();
        let lbs = expenses.concat(income);
        return new Chart($elm, {
            type: 'horizontalBar',
            data: {
                labels : lbs,
                datasets: [{
                    data : expenses,
                    borderWidth: 1,
                    backgroundColor : "rgba(239, 144, 0, 0.5)",
                    borderColor : "rgba(239, 144, 0, 1)",
                    reverse: true
                },
                {
                    data : income,
                    borderWidth: 1,
                    backgroundColor : "rgba(0, 128, 0, 0.5)",
                    borderColor : "rgba(0, 128, 0, 1)",
                    reverse: true
                }]
            },
            options: {
                tooltips: {
                    callbacks: {
                        label: function(tooltipItem, data) {
                            return "$" + tooltipItem.xLabel;
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero:true,
                            callback: function(value, index, values) {
                                console.log(value);
                                if(value){
                                    let y = value.y;
                                    return value.y;
                                }
                            }
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            beginAtZero:true,
                            callback: function(value, index, values) {
                                if(value > 0)
                                    return "-$" + Math.abs(value);
                                return '$' + value;
                            }
                        }
                    }]
                },
                legend: {
                    display: false,
                }
            }
        });
    },

    snapChart($elm, chartData, colNums, isIncome){
        $elm.empty();
        return new Chart($elm, {
            type: 'horizontalBar',
            data: {
                labels : chartData,
                datasets: [{
                    data : chartData,
                    borderWidth: 1,
                    backgroundColor : "rgba(" + colNums + ", 0.5)",
                    borderColor : "rgba(" + colNums + ", 1)",
                    reverse: true
                }]
            },
            options: {
                tooltips: {
                    callbacks: {
                        label: function(tooltipItem, data) {
                            return "$" + tooltipItem.xLabel;
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        position: (isIncome) ? "right" : "left",
                        ticks: {
                            beginAtZero:true,
                            callback: function(value, index, values) {
                                console.log(value);
                                let y = value.y;
                                return value;
                            }
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            reverse: (isIncome) ? true : false,
                            beginAtZero:true,
                            callback: function(value, index, values) {
                                return '$' + value;
                            }
                        }
                    }]
                },
                legend: {
                    display: false,
                }
            }
        });
    }
};

module.exports = Charts;


// WEBPACK FOOTER //
// ./src/control/util/Charts.js